if (!customElements.get('flexura-luxury-price')) {
  customElements.define(
    'flexura-luxury-price',
    class FlexuraLuxuryPrice extends HTMLElement {
      connectedCallback() {
        const productInfo = this.closest('product-info');
        this.sectionId = productInfo?.dataset.originalSection || productInfo?.dataset.section || this.dataset.section;

        if (
          typeof subscribe === 'function' &&
          typeof PUB_SUB_EVENTS !== 'undefined' &&
          PUB_SUB_EVENTS.variantChange
        ) {
          this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            if (event?.data?.sectionId !== this.sectionId || !event.data.variant) return;
            this.updateVariant(event.data.variant);
          });
        }
      }

      disconnectedCallback() {
        if (this.variantChangeUnsubscriber) this.variantChangeUnsubscriber();
      }

      updateVariant(variant) {
        const mainPrice = this.querySelector('[data-luxury-main-price]');
        const comparePrice = this.querySelector('[data-luxury-compare-price]');
        const saving = this.querySelector('[data-luxury-saving]');
        const variantInput = this.querySelector('[data-luxury-variant-input]');
        const hasSaving = Number(variant.compare_at_price) > Number(variant.price);

        if (mainPrice) mainPrice.innerHTML = this.formatMoney(variant.price);

        if (comparePrice) {
          comparePrice.hidden = !hasSaving;
          if (hasSaving) comparePrice.innerHTML = this.formatMoney(variant.compare_at_price);
        }

        if (saving) {
          saving.hidden = !hasSaving;
          if (hasSaving) {
            const percentage = Math.round(
              ((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100
            );
            saving.textContent = `SAVE ${percentage}%`;
          }
        }

        if (variantInput) {
          variantInput.value = variant.id;
          variantInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }

      formatMoney(cents) {
        if (window.Shopify?.formatMoney) {
          return Shopify.formatMoney(cents, this.dataset.moneyFormat);
        }

        const currency = window.Shopify?.currency?.active || 'USD';
        return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
          style: 'currency',
          currency,
        }).format(Number(cents) / 100);
      }
    }
  );
}
